

export const COLOR_PALETTE_ROADS = {
  egnatia: "#eb5514",
  paralia: "#cc0036",
  periferiakos: "#E98500",
  tsimiski: "#0095b3",
  // "" :"#9b2226",
  // "" :"#f4a261",
  // "" :"#2a9d8f",
};

export const DIAGRAM_COLORS = [
    "#eb5514", //dark orange
    "#cc0036", //red
    "#E98500", //orange
    "#0095b3", //blue
    "#9b2226", //dark red
    "#f4a261", //light orange
    "#2a9d8f", //green
]

export const primary = "#e91e63";
export const secondary = "#7b809a";
export const info = "#1A73E8";
export const success = "#4CAF50";
export const warning = "#fb8c00";
export const error = "#F44335";
export const light = "#f0f2f566";


export const networkPurple = "rgba(194, 91, 235, 1)";
export const networkPink = "rgba(255, 99, 132, 1)";
export const networkElectricBlue = "rgba(75, 192, 192, 1)";